import React, { useState } from 'react';
import ComparerIndicator from '../ComparerIndicator/ComparerIndicator'
import { EntityComplaint } from 'types/EntityComplaint';
import Const from '../../../const.json';
import './ListItemWithIcon.scss'

type ListItemWithIconProps = {
    complaint: EntityComplaint;
    index?: number;
    selectedIndexes?: boolean[];
    setSelectedIndexes?: (value: boolean[]) => void;
    isDecorationIcon?: boolean;
    isDirectionText?: boolean;
    ariaLabelText?: string;
};

const ListItemWithIcon: React.FC<ListItemWithIconProps> = (props) => {
    const { complaint, index, selectedIndexes, setSelectedIndexes, isDecorationIcon, isDirectionText = false, ariaLabelText = null } = props
    const { id, logo, description, complaintsCount, comparerData, complaintsPercent } = complaint;

    const isClick = () => index != null && selectedIndexes && setSelectedIndexes;

    const handleClick = () => {
        if (isClick()) {
            selectedIndexes[index] = !selectedIndexes[index];
            setSelectedIndexes([...selectedIndexes]);
        }
    }
    const filtered = selectedIndexes && !selectedIndexes[index]
    return (
        <div key={id} className={`list-item-with-icon-content ${filtered && 'filtered'}`} role={isClick() ? 'button' : undefined} onClick={isClick() ? handleClick : undefined}>
            <img className='icon' src={logo} alt={`${!isDecorationIcon ? (description + ' icon') : ''}`} />
            <div>
                <div className='sub-header' aria-label={ariaLabelText && `${ariaLabelText} ${Const.complaints}, ${complaintsPercent ?? complaintsCount}%`}>{complaintsPercent ?? complaintsCount}%</div>
                <p className='header-bold'>{description}</p>
                <div>
                    <ComparerIndicator comparerData={comparerData} isDirectionText={isDirectionText}/>
                </div>
            </div>
        </div>);
};

export default ListItemWithIcon;
